import { Controller } from "@hotwired/stimulus"
import { initColumnResize } from "../lib/init_column_resize"

// Standalone Stimulus controller for column resizing.
// Usage: add data-controller="column-resize" to a wrapper that contains a <table>.
// See lib/init_column_resize.js for full documentation.
// When we End Of Life the checkbox-select-all controller, we can move the initColumnResize code here.
export default class extends Controller {
  connect() {
    initColumnResize(this.element)
  }
}
